import { useTranslation } from "@outschool/localization";
import { FilterDropdown } from "@outschool/ui-components-website";
import _ from "lodash";
import React, { useState } from "react";

import * as Activity from "../../../../shared/Activity";
import Backdrop from "../../lib/Backdrop";
import AgeFilters from "../../search/AgeFilters";
import { createAgeString } from "../util";

const CategoriesAgeFilter = ({
  searchFiltersAge,
  setSearchFiltersAge,
}: {
  searchFiltersAge: string;
  setSearchFiltersAge: (age: string) => void;
}) => {
  const { t } = useTranslation(
    "client\\components\\categories\\CategoriesAgeFilter",
  );
  const [openFilterDropdown, setOpenFilterDropdown] = useState<string | null>(
    null,
  );
  const closeFilterDropdown = () => setOpenFilterDropdown(null);

  const ages = searchFiltersAge
    ? _.uniq(
        searchFiltersAge
          .split(",")
          .map(age => +age)
          .filter(age => age <= Activity.ageMax && age >= Activity.classAgeMin),
      )
    : [];

  const listOfAges = createAgeString(ages);

  return (
    <Backdrop show={!!openFilterDropdown} onClick={closeFilterDropdown}>
      <FilterDropdown
        filterName={t("Learner age")}
        filterValue={
          ages.length
            ? t("Age {{listOfAges}}", {
                count: ages.length,
                listOfAges,
                defaultValue_plural: "Ages {{listOfAges}}",
              })
            : undefined
        }
        open={openFilterDropdown === "age"}
        onClose={closeFilterDropdown}
        onOpen={() => setOpenFilterDropdown("age")}
        buttonSx={{
          padding: "1.1rem",
          "& > svg": {
            paddingTop: 0,
          },
        }}
      >
        <AgeFilters
          value={ages}
          onChange={value => {
            setSearchFiltersAge(value.length ? value.join(",") : "");
            closeFilterDropdown();
          }}
          onCancel={closeFilterDropdown}
        />
      </FilterDropdown>
    </Backdrop>
  );
};

export default CategoriesAgeFilter;
